import { render } from "./ImpersonateGrid.vue?vue&type=template&id=2a395836&scoped=true&ts=true"
import script from "./ImpersonateGrid.vue?vue&type=script&lang=ts"
export * from "./ImpersonateGrid.vue?vue&type=script&lang=ts"

import "./ImpersonateGrid.vue?vue&type=style&index=0&id=2a395836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a395836"]])

export default __exports__